const Surroundings = Object.freeze({
  HEALTHCARE: 'HEALTHCARE',
  EDUCATION: 'EDUCATION',
  SHOPPING: 'SHOPPING',
  GASTRONOMY: 'GASTRONOMY',
  PUBLIC_TRANSPORT: 'PUBLIC_TRANSPORT'
})

export default Surroundings
